import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";
import { removeTranslation } from "slices/translationSlice";
import { ListLayout } from "components/common/ListLayout";
import ConfirmationModal from "components/common/ConfirmationMessage";
import CotationPopup from "views/Translation/CotationPopup";
import { fetchInterpreterTranslationsList } from "slices/interpreter/interpreterTranslationSlice";
import { clientTranslationSelector } from "slices/interpreter/interpreterTranslationSlice";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { Check, X } from "lucide-react";
import CancelTranslationModal from "./CancelTranslationModal";
import transicon from "../../assets/img/transicon.png";
import transicon2 from "../../assets/img/transicon2.png";
import transicon3 from "../../assets/img/transicon3.png";
import transicon4 from "../../assets/img/transicon4.png";
import Swal from "sweetalert2";
import Api from "services/api";
import moment from "moment";
import { Controller, useForm } from "react-hook-form";
import { languageSelector } from "slices/languageSlice";
import { LegendButton } from "components/common/TableColor";
import { fetchLanguages } from "slices/languageSlice";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import ErrorMessage from "components/common/ErrorMessage";
import { filteredStatusINterpreter } from "components/common/TableColor";
import { fetchTranslators } from "slices/TranslatorNameSlice";

function Translation() {
  const [cotationPopup, setCotationPopup] = React.useState({
    open: false,
    documents: [],
  });
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const {
    interpreterTranslations,
    last_page: totalPages,
    loader,
    total,
    current_page,
    per_page: pageLength,
  } = useSelector(clientTranslationSelector) || {};
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {},
  });
  const refAddutton = React.useRef(null);
  const navigate = useNavigate();

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [translationPageLength, setTranslationPageLength] = useState(10);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [cancelModal, setCancelModal] = React.useState(false);
  const [acceptModal, setAcceptModal] = React.useState(false);
  const [cancelTransId, setCancelTransId] = React.useState(null);
  const { language: languages } = useSelector(languageSelector);
  const [status, setStatusValue] = React.useState("all");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: "name",
    sortDirection: "asc",
  });

  const {
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setError: setErrors,
    reset,
  } = useForm({
    defaultValues: {
      start_date: moment().format("YYYY/MM/DD"),
      end_date: moment().format("YYYY/MM/DD"),
      translator: null,
      client: null,
      source_language: null,
      target_language: null,
    },
  });

  // Disabled popup logic, now navigates to /add-translation
  const handleAddLanguagePopUp = () => {
    setTimeout(() => {
      navigate("/translation/create");
    }, 300);
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      });
      setSelectedItems([]);
      setSelectAll(false);
      dispatch(fetchInterpreterTranslationsList());
      hideConfirmDialog();
    } else {
      toast.error(message, {
        className: "errorToast",
      });
    }
  };



  const values = getValues();
  const getAllFilters = useMemo(() => {
    const params = {
      start_date: values.start_date || moment().format("YYYY/MM/DD"),
      end_date: values.end_date || moment().format("YYYY/MM/DD"),
      status: status || null,
      translator: values.translator || null,
      client: values.client || null,
      source_language: values.source_language || null,
      target_language: values.target_language || null,
    };

    // Remove empty/null
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === "") {
        delete params[key];
      }
    });

    return params;
  }, [values, status]);


  const showConfirmDialog = () => {
    setDeleteModal(true);
    return;
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  };
  const handleRemoveItems = () => {
    selectedItems.forEach((id) => {
      dispatch(removeTranslation(id, submitCallback));
    });
  };
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value;
    setSelectedItems(
      selectedItems.includes(id)
        ? selectedItems.filter((item) => item != id)
        : [...selectedItems, id]
    );
  };
  // const handleToggleSelectAll = () => {
  //   if (selectAll) {
  //     setSelectedItems([]);
  //     setSelectAll(false);
  //     return;
  //   }
  //   setSelectAll(true);
  //   setSelectedItems(
  //     interpreterTranslations?.map((translation) => translation.id.toString())
  //   );
  // };

  // const handlePageChange = React.useCallback((page) => {
  //   setCurrentPage(page);
  //   dispatch(fetchInterpreterTranslationsList(page));
  // }, []);

  // const handleClose = () => {
  //   refAddutton.current.click();
  //   setAddForm({ show: false });
  // };

  // const handleSelect = (value) => {
  //   setSelectedValue(value);
  // };

  //#region TABLE HEAD

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(
        fetchInterpreterTranslationsList(currentPage, {
          sortBy: sortBy,
          sortDirection: dir,
          search: searchTerm,
        })
      );
    };
    return (
      <tr>
        <th className="table-col">#</th>
        <th className="table-col">ProjectID</th>
        <th className="table-col">Client</th>
        <th className="table-col">Source</th>
        <th className="table-col">Target</th>
        <th className="table-col">Total Count</th>
        {/* <th className="table-col">Total Est. Amount</th> */}
        <th className="table-col">Received Date</th>
        <th className="table-col">Status</th>
        {/* {checkPermission("Edit Translations") && ( */}
        <th className="table-col">Actions</th>
        {/* )} */}
      </tr>
    );
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion

  const startDateRef = React.useRef(null);
  const endDateRef = React.useRef(null);


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    const safeTranslations = Array.isArray(interpreterTranslations?.data)
      ? interpreterTranslations.data
      : [];
    return safeTranslations.map((translation, index) => (
      <TranslationItem
        translation={translation}
        index={index}
        selectedItems={selectedItems}
        handleChange={handleChange}
        handleAddPopUp={handleAddLanguagePopUp}
        current_page={current_page}
        pageLength={pageLength}
        checkPermission={checkPermission}
        dispatch={dispatch}
        setCancelModal={setCancelModal}
        setAcceptModal={setAcceptModal}
        setCancelTransId={setCancelTransId}
        paginationParams={getAllFilters}
        onReviseQoute={() => {
          setCotationPopup({
            open: true,
            documents: translation.documents || [
              {
                name: "01091_1560_1771_1680.pdf / Afrikaans",
                wordCount: 93,
                rate: 0.13,
                formatting: 0.0,
                amount: 15.73,
              },
              {
                name: "01091_1560_1771_1680.pdf / Berber",
                wordCount: 93,
                rate: 0.13,
                formatting: 0.0,
                amount: 15.73,
              },
              {
                name: "01091_1560_1771_1680.pdf / Egyptian Arabic",
                wordCount: 93,
                rate: 0.13,
                formatting: 0.0,
                amount: 15.73,
              },
            ],
            transId: translation.id,
          });
        }}
      />
    ));
  }, [interpreterTranslations, selectedItems]);

  const handleCloseCancel = () => {
    setCancelModal(false);
    setCancelTransId(null);
    dispatch(fetchInterpreterTranslationsList(1, getAllFilters));
  };

  const handleSubmitss = () => { };

  // #region Target Language dropdown
  const [targetLanguageState, setTargetLanguageState] = React.useState([]);
  const [activeLegend, setActiveLegend] = React.useState(0);

  // Pills Filter Function Headers...
  const hanldeActiveLegend = (id, value) => {
    setActiveLegend(id);
    setStatusValue(value);

    const params = {
      start_date: values.start_date || moment().format("YYYY/MM/DD"),
      end_date: values.end_date || moment().format("YYYY/MM/DD"),
      status: value,
      translator: values.translator || null,
      client: values.client || null,
      source_language: values.source_language || null,
      target_language: values.target_language || null,
      pagelength: translationPageLength
    };

    Object.keys(params).forEach((key) => {
      if (params[key] === null || params[key] === "") {
        delete params[key];
      }
    });

    // API call
    dispatch(fetchInterpreterTranslationsList(1, params));
  };

  React.useEffect(() => {
    dispatch(fetchInterpreterTranslationsList(1, values));
  }, [dispatch]);

  // Source Language
  const [sourceLanguageState, setSourceLanguageState] = React.useState([]);

  React.useEffect(() => {
    dispatch(fetchTranslators()); // API call for Translators
  }, [dispatch]);

  React.useEffect(() => {
    const formValue = getValues("source_language_id");
    if (formValue && Array.isArray(formValue) && formValue.length > 0) {
      setSourceLanguageState(
        languages
          ?.filter((lang) => formValue.includes(lang.id))
          ?.map((val) => ({
            label: val?.name || "",
            value: val?.id || "",
          }))
      );
    }
  }, [languages, getValues]);

  const filteredLanguagesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchLanguages(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      hasMore: page !== result?.last_page ? true : false,
      additional: {
        page: page + 1,
      },
    };
  };

  // Translation Cards
  const renderCards = () => {
    return (
      <>
        {/* Cards Section  */}
        <div className="d-flex w-100 gap-3 interpreter_translations_boxes" style={{ marginTop: "14px" }}>
          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Total Projects</span>
              <img style={{ width: 24 }} src={transicon} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {interpreterTranslations?.total}
            </span>
          </div>

          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Under Review</span>
              <img style={{ width: 24 }} src={transicon2} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {interpreterTranslations?.under_review}
            </span>
          </div>

          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Completed</span>
              <img style={{ width: 24 }} src={transicon3} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {interpreterTranslations?.completed}
            </span>
          </div>

          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Cancelled</span>
              <img style={{ width: 24 }} src={transicon4} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {interpreterTranslations?.cancelled}
            </span>
          </div>
        </div>
      </>
    );
  };

  const filteredStatus = React.useMemo(() => {
    const temp_array = [...filteredStatusINterpreter];
    temp_array.unshift({
      value: "all",
      name: "All",
      id: 0,
      color: "#3176A0",
    });
    return temp_array;
  }, [filteredStatusINterpreter]);

  // Filters onsubmit
  const onSubmit = (values) => {
    setSearchTerm("");
    const params = {
      start_date: values.start_date
        ? moment(values.start_date).format("YYYY/MM/DD")
        : null,
      end_date: values.end_date
        ? moment(values.end_date).format("YYYY/MM/DD")
        : null,
      translator: values.translator ?? null,
      client: values.client ?? null,
      source_language: values.source_language ?? null,
      target_language: values.target_language ?? null,
      status: status ?? null,
    };

    Object.keys(params).forEach((key) => {
      if (!params[key]) delete params[key];
    });

    dispatch(fetchInterpreterTranslationsList(1, params));
  };

  console.log("status", status);
  // Reset function
  const handleResetFields = () => {
    setSearchTerm("");
    reset({
      start_date: moment().format("YYYY/MM/DD"),
      end_date: moment().format("YYYY/MM/DD"),
      client: null,
      translator: null,
      source_langauge: null,
      target_language: null,
    });
    setTargetLanguageState(null);
    setSourceLanguageState(null);

    dispatch(fetchInterpreterTranslationsList({}));
  };

  // Filter section
  const renderFilters = () => {
    return (
      <>
        <div className="container-fluid p-0">
          {/* Row 1 */}
          <div className="d-flex justify-content-start flex-wrap mb-4">
            {/* Status */}
            <LegendButton
              activeId={activeLegend}
              options={filteredStatus}
              handleClick={hanldeActiveLegend}
            />
          </div>

          {/* Row 2 */}
          <div className="row gx-4 gy-3 align-items-center">
            {/* Start Date */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3 translation_filter_fields">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Start Date
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="start_date"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image basic_bases">
                      <input
                        ref={startDateRef}
                        id="start_date"
                        type="date"
                        name="start_date"
                        placeholder="Start Date"
                        {...field}
                        value={
                          field.value
                            ? moment(field.value).format("YYYY-MM-DD")
                            : moment().format("YYYY-MM-DD") // fallback current date
                        }
                        onChange={(e) => {
                          const dateString = moment(
                            new Date(e.target.value)
                          ).format("YYYY/MM/DD");
                          field.onChange(dateString);
                        }}
                      />
                      <img
                        src="/images/celender.png"
                        alt="celender Icon"
                        className="custom-icon"
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* End Date */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3 translation_filter_fields">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                End Date
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="end_date"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image basic_bases">
                      <input
                        ref={endDateRef}
                        type="date"
                        name="end_date"
                        placeholder="End Date"
                        {...field}
                        value={
                          field.value
                            ? moment(field.value).format("YYYY-MM-DD")
                            : moment().format("YYYY-MM-DD")
                        }
                        onChange={(e) => {
                          const dateString = moment(
                            new Date(e.target.value)
                          ).format("YYYY/MM/DD");
                          field.onChange(dateString);
                        }}
                      />
                      <img
                        src="/images/celender.png"
                        alt="celender Icon"
                        className="custom-icon"
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* Interpreter */}
            {/* <div className="col-12 col-md-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Translator
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="translator"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={
                          field.value
                            ? translatorOptions.find(
                                (opt) =>
                                  String(opt.value) === String(field.value)
                              )
                            : null
                        }
                        loadOptions={translatorLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => field.onChange(obj?.value ?? null)}
                        additional={{ page: 1 }}
                      />
                    </div>
                  )}
                />
              </div>
            </div> */}

            {/* Source Language */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3 translation_filter_fields">
              <h2
                className="mb-0 form-label text-wrap"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Source Language
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="source_language"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <div style={{ width: "100%" }}>
                        <AsyncPaginate
                          menuPlacement="auto"
                          styles={{
                            ...selectCustomStyles,
                          }}
                          value={sourceLanguageState}
                          loadOptions={filteredLanguagesLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(selected) => {
                            setSourceLanguageState(selected);
                            field.onChange(selected ? selected.value : null);
                          }}
                          additional={{
                            page: 1,
                          }}
                        />
                      </div>
                      {errors?.source_language_id?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage
                            text={errors?.source_language_id?.message}
                          />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>
            </div>
          </div>

          {/* Row 3 */}
          <div className="row mt-1 gx-4 gy-3 align-items-center">
            {/* Clients */}
            {/* <div className="col-12 col-md-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Clients
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="client"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={
                          field.value
                            ? options.find((opt) => field.value === opt.value)
                            : null
                        }
                        loadOptions={loadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => field.onChange(obj?.value ?? null)}
                      />
                    </div>
                  )}
                />
              </div>
            </div> */}

            {/* Source Language */}
            {/* <div className="col-12 col-md-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label text-wrap"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Source Language
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="source_language"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <div style={{ width: "100%" }}>
                        <AsyncPaginate
                          menuPlacement="auto"
                          styles={{
                            ...selectCustomStyles,
                          }}
                          value={sourceLanguageState}
                          loadOptions={filteredLanguagesLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(selected) => {
                            setSourceLanguageState(selected);
                            field.onChange(selected ? selected.value : null);
                          }}
                          additional={{
                            page: 1,
                          }}
                        />
                      </div>
                      {errors?.source_language_id?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage
                            text={errors?.source_language_id?.message}
                          />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>
            </div> */}

            {/* Target Language */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3 translation_filter_fields">
              <h2
                className="mb-0 form-label text-wrap"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Target Language
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="target_language"
                  control={control}
                  // rules={{ required: "Language must be specified" }}
                  defaultValue={null} // important for single-select
                  render={({ field }) => (
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={targetLanguageState} // should be a single option object or null
                        loadOptions={filteredLanguagesLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(selected) => {
                          // selected is an object or null in single-select mode
                          setTargetLanguageState(selected);
                          field.onChange(selected ? selected.value : null);
                        }}
                        onBlur={field.onBlur}
                        additional={{ page: 1 }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
          </div>

          {/* Buttons row */}
          <div className="row-primary btns_area row_10 mb-0">
            <SubmitButton
              handleSubmit={() => handleSubmit(onSubmit)()}
              buttonType="button"
              btnText="Search"
              className={"green"}
            />
            <SubmitButton
              buttonType="button"
              className={"lightBlue"}
              btnText="Reset"
              handleSubmit={handleResetFields}
            />
          </div>
        </div>
      </>
    );
  };

  const fetchList = React.useCallback(
    (page, params) => async (dispatch) => {
      const fetchParams = { ...params, page };
      dispatch(fetchInterpreterTranslationsList(page, fetchParams));
    },
    []
  );

  //#endregion
  return (
    <>
      <CancelTranslationModal
        isOpen={cancelModal}
        onClose={handleCloseCancel}
        onConfirm={handleSubmitss}
        transId={cancelTransId}
      />

      <ListLayout
        heading="Special Projects"
        time={true}
        title=""
        buttonTitle="Add Project"
        renderTableHeader={renderTableHeader}
        renderFilters={renderFilters}
        renderCards={renderCards}
        renderTableContent={renderTableContent}
        totalPages={totalPages}
        addButtonDisabled={true}
        fetchList={fetchList}
        selectedItems={selectedItems}
        handleRemoveItems={handleRemoveItems}
        pageLengthChange={setTranslationPageLength}
        // Disable popup: do not render add form
        renderAddForm={null}
        paginationParams={getAllFilters}
        renderAddLink={(callback) => (
          // TODO add permission
          <Link to="/translation/create" className="main_button ml-4">
            {"Add Project"}
          </Link>
        )}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddLanguagePopUp}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        loader={loader}
        noOfItems={total}
        disableBootstrap={true}
        searchPlaceholder="Search Project ..."
      >
        {deleteModal && (
          <ConfirmationModal
            onClose={hideConfirmDialog}
            isOpen={deleteModal}
            onConfirm={handleRemoveItems}
          />
        )}
      </ListLayout>
      <CotationPopup
        open={cotationPopup.open}
        onClose={() => setCotationPopup({ open: false, documents: [] })}
        documents={cotationPopup.documents}
        transId={cotationPopup.transId}
      />
    </>
  );
}

const TranslationItem = ({
  translation,
  index,
  selectedItems,
  handleChange,
  current_page,
  pageLength,
  checkPermission,
  setCancelModal,
  setCancelTransId,
  dispatch,
  paginationParams,
}) => {
  // const [status, setStatus] = React.useState(
  //   translation?.status == "active" ? 1 : 0 || 0
  // );

  // React.useEffect(() => {
  //   setStatus(translation?.status == "active" ? 1 : 0 || 0);
  // }, [translation]);
  // // You can implement status change logic for translation if needed
  // const getBackgroundStyle = (status) => {
  //   return status === 0 ? { background: "#f4f4f4" } : {};
  // };

  const getBackgroundStyle = (status) => {
    switch (status) {
      case "Cancelled":
      case "Client Cancelled":
      case "Quote Rejected":
        return { background: "#FFF0F0" };
      case "Translator Declined":
        return { background: "#F7C8C5" };
      case "Under Review":
        return { background: "#f1ebff" };
      case "New Request":
        return { background: "#FFF1D4" };
      case "Completed":
        return { background: "#D2D5D5" };
      case "Quote Sent":
        return { background: "#D6E4EC" };
      case "Quote Approved":
        return { background: "#EBFEED" };
      case "Quote Revised":
        return { background: "#f4e9ff" };
      case "Invoice Sent":
        return { background: "#DDE1FE" };
      case "Translators Invited":
        return { background: "#CBD1DC" };
      case "Assigned":
        return { background: "#DCEBFE" };
      default:
        return { background: "#ffffff" };
    }
  };

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);

  const onApprove = async (transId) => {
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure, you want to accept the invite?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
      customClass: {
                cancelButton: 'main_button  tomatoRed',
                confirmButton: 'swal-btn',
            },
    });
    if (result.isConfirmed) {
      try {
        const res = await Api.acceptTranslationById(transId);
        if (res?.status === 200) {
          toast.success(res?.data?.message || "Invite accepted successfully", {
            className: "successToast",
          });
          dispatch(fetchInterpreterTranslationsList(1, paginationParams));
        } else {
          toast.error(res?.data?.message || "Failed to accept invite", {
            className: "errorToast",
          });
        }
      } catch (error) {
        toast.error("An error occurred while accepting invite", {
          className: "errorToast",
        });
      }
    }
  };

  const statusMap = {
    "Translators Invited": "Invited",
    "Invoice Sent": "Submission Approved",
    "Client Cancelled": "Cancelled",
    "Quote Sent": "Quote Received",
  };

  return (
    <>
      <tr>
        <td style={getBackgroundStyle(translation?.status)}>
          <div className="row_check">
            <span>{serial}</span>
            {checkPermission("Delete Translations") && (
              <label className="custom-checkbox checkbox">
                <input
                  type="checkbox"
                  name="select-all"
                  data-value={translation.id}
                  checked={selectedItems.includes(translation.id.toString())}
                  onChange={handleChange}
                />
                <span className="checkmark"></span>
              </label>
            )}
          </div>
        </td>
        <td style={getBackgroundStyle(translation?.status)}>
          <Link
            to={`/interpreter/translation/view/${translation.id}`}
            style={{
              color: "#6F8DFF",
              cursor: "pointer",
              textDecoration: "underline",
              fontWeight: 500,
            }}
          >
            {translation.transid}
          </Link>
        </td>
        <td style={getBackgroundStyle(translation?.status)}>
          {translation?.accounts?.user?.name}
        </td>
        <td style={getBackgroundStyle(translation?.status)}>
          {translation.language?.name}
        </td>
        <td style={getBackgroundStyle(translation?.status)}>
          {Array.isArray(translation.translation_target_languages)
            ? translation.translation_target_languages
              .map((tl) => tl.language?.name)
              .join(", ")
            : ""}
        </td>

        {/* <td style={getBackgroundStyle(status)}>{translation.requester_name}</td> */}

        <td style={getBackgroundStyle(translation?.status)}>
          {translation.total_words_count}
        </td>
        {/* <td style={getBackgroundStyle(status)}>{translation.est_words_count}</td> */}
        {/* <td style={getBackgroundStyle(translation?.status)}>
          {translation.total_amount}
        </td> */}
        <td style={getBackgroundStyle(translation?.status)}>
          {convertTimeToUTC(translation.created_at)}
        </td>
        <td style={getBackgroundStyle(translation?.status)}>
          {/* {translation.status === "Translators Invited"
            ? "Invited"
            : translation?.status === "Invoice Sent"
            ? "Submission Approve"
            : translation.status} */}
          {statusMap[translation.status] || translation.status}
        </td>

        <td style={getBackgroundStyle(translation?.status)}>
          {translation.interpreter_id === null &&
            translation?.translation_invites[0]?.status === "pending" ? (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <button
                onClick={() => {
                  onApprove(translation.id);
                }}
                type="danger"
                style={{
                  backgroundColor: "green",
                  borderRadius: "50%",
                  border: "none",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <Check color="#FFF" size={20} />
              </button>
              <button
                onClick={() => {
                  setCancelModal(true);
                  setCancelTransId && setCancelTransId(translation.id);
                }}
                type="danger"
                style={{
                  backgroundColor: "red",
                  borderRadius: "50%",
                  border: "none",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <X color="#FFF" size={20} />
              </button>
            </div>
          ) : null}
        </td>
      </tr>
    </>
  );
};

export default Translation;
